export default "__VITE_ASSET__OKTbfySU__"